import React from 'react';
import {Props} from './Props';
import MessageAgeInMinutes from '../../../../../../components/MessageAgeInMinutes';
import TimeFormatted from '../../../../../../components/TimeFormatted';

const DialogWazeIrregularity: React.FunctionComponent<Props> = ({currentProperties, showRecordIds}) => {
    return (
        <table>
            <tbody>
                {showRecordIds && (
                    <tr>
                        <th>ID</th>
                        <td>{currentProperties.id}</td>
                    </tr>
                )}
                <tr>
                    <th>Type</th>
                    <td>
                        {currentProperties.type}
                    </td>
                </tr>
                <tr>
                    <th>Starttijd</th>
                    <td>
                        <TimeFormatted dateTime={currentProperties.startedAt} />
                    </td>
                </tr>
                <tr>
                    <th>Duur incident</th>
                    <td>
                        <MessageAgeInMinutes time={currentProperties.startedAt} />
                    </td>
                </tr>
                <tr>
                    <th>Locatie</th>
                    <td>
                        {currentProperties.address} {currentProperties.city}
                    </td>
                </tr>
                <tr>
                    <th>Bevestigingen</th>
                    <td>{currentProperties.confirmedCount}</td>
                </tr>
                <tr>
                    <th>Zwaarte</th>
                    <td>{currentProperties.jamLevel} (1-4, 4 = stilstaande file)</td>
                </tr>
            </tbody>
        </table>
    );
};

export default DialogWazeIrregularity;
